module.exports = __webpack_public_path__ + "img/2016.05c2a6c8.svg";